import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'
import { getLocalStorage } from '@/helpers/site'

// import all routes
import routes from '@/router/routes'

Vue.use(VueRouter)
const DEFAULT_TITLE = 'MINTIA'

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('settings/init')

  if (
    !getLocalStorage() &&
    ![
      'home',
      'faq',
      'term',
      'select-layout',
      'select-template',
      'pc-screen',
    ].includes(to.name)
  ) {
    return next({ name: 'home' })
  }

  if (
    to.matched.some(record => record.meta.guard === 'module') &&
    from.name !== 'preview'
  ) {
    return next({ name: 'preview' })
  }

  next()
})

router.afterEach(to => {
  Vue.nextTick(() => {
    document.body.classList.remove('no-scroll')
    document.title = to.meta.title || DEFAULT_TITLE
  })
})

export default router
